import { useRef } from "react";
import { Menu } from "primereact/menu";
import { classNames } from "primereact/utils";
import localeText from "../../../../../locale";
import { downloadDocument, getUserDocuments, openDocument } from "../userDocuments";

const UserActions = ({ user, showDocuments, busy, onToggleBlock }) => {
  const menuRef = useRef(null);
  const documents = showDocuments ? getUserDocuments(user) : [];
  const menuId = `admin-users-docs-${user.id ?? user.username}`;

  const documentItems = documents.flatMap((doc) => [
    {
      label: `${localeText("seeDoc")} ${doc.number}`,
      icon: "pi pi-external-link",
      command: () => openDocument(doc.url),
    },
    {
      label: `${localeText("downloadDoc")} ${doc.number}`,
      icon: "pi pi-download",
      command: () => downloadDocument(doc.url),
    },
  ]);

  // Conta cancelada não tem username real para bloquear/desbloquear
  if (user.cancelled && documentItems.length === 0) {
    return <span className="admin-muted">—</span>;
  }

  return (
    <div className="admin-users-actions">
      {!user.cancelled && (
        <button
          type="button"
          className={classNames("admin-btn", { "admin-btn--danger-hover": !user.blocked })}
          onClick={() => onToggleBlock(user)}
          disabled={busy}
        >
          <i
            className={busy ? "pi pi-spin pi-spinner" : user.blocked ? "pi pi-lock-open" : "pi pi-lock"}
            aria-hidden="true"
          />
          <span>{localeText(user.blocked ? "unblock" : "block")}</span>
        </button>
      )}

      {documentItems.length > 0 && (
        <>
          <button
            type="button"
            className="admin-icon-btn"
            onClick={(event) => menuRef.current.toggle(event)}
            aria-haspopup
            aria-controls={menuId}
            aria-label={localeText("documents")}
            title={localeText("documents")}
          >
            <i className="pi pi-file" aria-hidden="true" />
          </button>
          <Menu model={documentItems} popup ref={menuRef} id={menuId} />
        </>
      )}
    </div>
  );
};

export default UserActions;
